export default function getColorFromTicks(ticks, gg, bb, start_00, stop_FF) {
  let rr = "00";

  let trend = 1;

  if (start_00 < stop_FF) {
    trend = -1;
  }

  let y0 = (255 * trend) / ((start_00 - stop_FF) / start_00);

  rr = trend * (y0 - (y0 / start_00) * ticks);

  let int_rr = parseInt(rr);

  // podesimo limite
  if (int_rr > 255) int_rr = 255;
  if (int_rr < 0) int_rr = 0;

  let hex_rr = int_rr.toString(16);

  // const color = "#" + hex_rr + gg + bb;
  // console.log(color);

  return "#" + hex_rr + gg + bb;
  // 288000000000 - 8h i sve preko -> 00
  // 216000000000 - 6h i sve preko -> 00
  // 36000000000 - 1h već treba da he -> FF
  // 0 -> FF
}
